import UpdateTransactionRequestModelBase from '../_generated/modelBases/update-transaction-request-model-base';

export default class UpdateTransactionRequestModel extends UpdateTransactionRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
